// src/components/TermsAndConditions.js
import React, { useEffect } from 'react';
import '../css/TermsAndConditions.css'; // Link to the new CSS file

// Assuming you have a general banner image for terms and conditions
import TermsBannerImage from '../assets/hotel4.avif'; // You can use any suitable image

export default function TermsAndConditions() {
    // Scroll to top on component mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="terms-wrapper">
            {/* Hero Banner */}
            <div className="terms-banner" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${TermsBannerImage})` }}>
                <h1>Terms & Conditions</h1>
                <p>Understanding our policies for a smooth experience.</p>
            </div>

            {/* Main Content Area */}
            <div className="terms-content-container">
                <section className="terms-section">
                    <h2>1. Introduction to No Brokerage Paying Guest</h2>
                    <p>
                        Welcome to the official terms and conditions for services provided by **No Brokerage Paying Guest**, operating under the brand **No Brokerage Paying Guest**. Our aim is to offer premium, safe, and comfortable accommodation solutions in Mumbai. By accessing and using our services, you agree to comply with and be bound by the following terms and conditions.
                    </p>
                    <div className="company-profile">
                        <h3>Company Profile</h3>
                        <p>
                            <strong>Partner:</strong> Sweta Rita<br />
                            <strong>Company:</strong> No Brokerage Paying Guest
                        </p>
                        <p>
                            No Brokerage Paying Guest is a trusted provider of premium accommodation solutions in Mumbai, specializing in student housing, independent women’s accommodations, and corporate housing. With over a decade of experience, we pride ourselves on offering safe, comfortable, and well-equipped living spaces. Our strict policies ensure a respectful and productive environment, with a zero-tolerance stance on alcohol, smoking, and unauthorized visitors.
                        </p>
                        <p>
                            We operate across key locations like Malad, Goregoan and Kandivali, and are known for our strong partnerships with platforms like JustDial, 99acres, NoBroker, and MagicBricks.
                        </p>
                    </div>
                </section>

                <section className="terms-section strict-policies-section">
                    <h2>2. Strict Operational Policies</h2>
                    <p>
                        To ensure a safe, productive, and respectful environment for all residents, we adhere to the following strict operational policies. Violation of these policies may lead to immediate termination of accommodation without refund.
                    </p>
                    <ul className="policy-list">
                        <li>
                            <span className="policy-icon">❌</span> <strong>Alcohol:</strong> Consumption or storage of alcohol is strictly prohibited on premises.
                        </li>
                        <li>
                            <span className="policy-icon">❌</span> <strong>Smoking:</strong> Smoking (including e-cigarettes and vaping) is strictly prohibited within the premises.
                        </li>
                        <li>
                            <span className="policy-icon">❌</span> <strong>Non-vegetarian Cooking/Eating:</strong> Cooking or consumption of non-vegetarian food is strictly prohibited within the premises to maintain a harmonious living environment for all residents.
                        </li>
                        <li>
                            <span className="policy-icon">🚫</span> <strong>Controlled Access:</strong> No unauthorized visitors are allowed. This policy is in place to ensure confidentiality, security, and minimize distractions for all residents.
                        </li>
                        <li>
                            <span className="policy-icon">🔍</span> <strong>Regular Compliance Checks:</strong> Our team conducts random visits to ensure adherence to these policies, maintaining a high standard of integrity and accountability.
                        </li>
                    </ul>
                </section>

                <section className="terms-section">
                    <h2>3. Our Accommodation Services</h2>
                    <p>We provide a comprehensive range of accommodation services tailored to various needs:</p>
                    <ul className="services-list">
                        <li>Accommodation for Boys, Girls, and Working Women</li>
                        <li>Fully furnished rooms with essential amenities</li>
                        <li>Amenities include Wi-Fi, TV, fridge, washing machine, and air conditioning (where applicable)</li>
                        <li>Dedicated 24x7 Security for peace of mind</li>
                        <li>Focus on providing value for your money</li>
                    </ul>
                </section>

                <section className="terms-section">
                    <h2>4. Office & Contact Information</h2>
                    <p>
                        For any inquiries or assistance, you can reach out to us at our main office or via email:
                    </p>
                    <ul className="contact-info-list">
                        <li>
                            <strong>Malad East Office:</strong> Opp. Blue Diamond, Malad East, Mumbai
                        </li>
                        <li>
                            <strong>Email:</strong> <a href="mailto:swetarita25786@gmail.com">swetarita25786@gmail.com</a>
                        </li>
                        <li>
                            <strong>Founder:</strong> Miss. Sweta Rita
                        </li>
                    </ul>
                </section>

                <section className="terms-section">
                    <h2>5. Acceptance of Terms</h2>
                    <p>
                        By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. No Brokerage Paying Guest reserves the right to modify these terms at any time without prior notice. Your continued use of our services after any such modifications constitutes your acceptance of the new Terms and Conditions.
                    </p>
                </section>
            </div>
        </div>
    );
}